module.exports = __webpack_public_path__ + "static/media/30.b60578f7.jpg";